import { create } from "zustand";

const playerConfigStore = create((set, get) => ({
  playerConfigs: {}, // Lưu trữ tất cả các player và config của họ

  // Cập nhật một config trong một player cụ thể
  updateSingleConfig: (playerId, configId, value) => {
    if (value === get().playerConfigs[playerId][configId]) {
      return;
    }
    set((state) => (
      {
        playerConfigs: {
          ...state.playerConfigs,
          [playerId]: {
            ...state.playerConfigs[playerId], // Giữ lại các config cũ
            [configId]: value, // Cập nhật config cụ thể
          },
        },
      }))
  },

  // Cập nhật toàn bộ config của một player
  updatePlayerConfig: (playerId, newConfig) =>
    set((state) => ({
      playerConfigs: {
        ...state.playerConfigs,
        [playerId]: newConfig, // Cập nhật toàn bộ config của player
      },
    })),

  // Cập nhật nhiều player cùng lúc
  updateMultiplePlayers: (newConfigs) =>
    set((state) => ({
      playerConfigs: {
        ...state.playerConfigs,
        ...newConfigs, // Merge với configs hiện tại
      },
    })),
}));

export default playerConfigStore;
